import React from "react";
import { Card } from "react-bootstrap";

const AchievementsCards = ({ title, date, img }) => {
  return (
    <div style={{ flex: "1 1 250px", minWidth: "250px", maxWidth: "300px" }}>
      <Card
        className="shadow-lg"
        style={{
          borderColor: "#FEB12F",
          width: "100%",
          height: "350px",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Card.Body className="d-flex flex-column align-items-center justify-content-between">
          <img
            src={img}
            alt="Achievement Certificate"
            className="img-fluid mb-3 border border-warning p-4 shadow-lg"
            style={{
              width: "185px",
              height: "165px",
              borderRadius: "80px",
              objectFit: "cover",
            }}
          />
          <h5
            className="card-title text-center border border-warning shadow"
            style={{
              color: "black",
              padding: "10px 20px",
              borderRadius: "15px",
              display: "inline-block",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            {title}
          </h5>

          <h6 className="text-success">{date}</h6>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AchievementsCards;
